import React from "react";
import type { PageInstanceSummary } from "./PageInstanceSummary";
const fallbackPageInstanceSummary: PageInstanceSummary = { Id: "App", Area: "App", instanceId: "fallback", routeParams: {}, routeTemplate: "fallback", owner: "fallback" };
const PageInstanceSummaryContext = React.createContext<PageInstanceSummary | undefined | "no-context">("no-context");
interface PageProviderProps {
    page: PageInstanceSummary | undefined;
    children: React.ReactNode;
}
export function PageInstanceSummaryProvider({ page, children }: PageProviderProps) {
    return <PageInstanceSummaryContext.Provider value={page}>{children}</PageInstanceSummaryContext.Provider>;
}
export function usePageInstanceSummary() {
    const page = React.useContext(PageInstanceSummaryContext);
    if (page === "no-context") {
        throw new Error("PageInstanceSummaryProvider has not been rendered above this component.");
    }
    if (page === undefined) {
        return fallbackPageInstanceSummary;
    }
    return page;
}
